"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgItalic(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M5.766 24a.766.766 0 01-.104-1.525l.104-.007h2.478l5.71-20.937h-2.06A.766.766 0 0111.79.008L11.894 0h6.127a.766.766 0 01.104 1.525l-.104.007-2.479-.001-5.71 20.937h2.062a.766.766 0 01.104 1.525l-.104.007H5.766z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgItalic;
exports.default = _default;